import { Skeleton } from '@mui/material';
import { useRouteActions } from 'app/agriculture/router/useRouteActions';
import { ContentBox } from 'app/agriculture/components/ContentBox/ContentBox';
import { SimpleGrid } from 'app/agriculture/components/SimpleGrid/SimpleGrid';

import { Actions } from 'app/agriculture/components/Actions/Actions';
import { StatDisplay } from 'app/agriculture/components/StatDisplay/StatDisplay';
import { NoteIcon } from 'app/agriculture/icons';
import { ContentBoxSkeleton } from 'app/agriculture/components/ContentBox/ContentBoxSkeleton';

export function NoteDetailsSkeleton() {
    const routeActions = useRouteActions();

    return (
        <ContentBoxSkeleton title="Note Details" Icon={NoteIcon} variant="lg">
            <ContentBox.Section scrollable>
                <ContentBox.Section>
                    <SimpleGrid columns={3}>
                        <StatDisplay
                            id="note-author"
                            name="Author"
                            value={<Skeleton variant="text" />}
                        />
                        <StatDisplay
                            id="note-timestamp"
                            name="Created"
                            value={<Skeleton variant="text" />}
                        />
                    </SimpleGrid>
                </ContentBox.Section>
                <ContentBox.Section className="NoteDetails__content">
                    <h5>Note</h5>
                    <Skeleton variant="text" height={180} />
                </ContentBox.Section>
                <Actions
                    sticky
                    backAction={{
                        startIcon: 'back',
                        text: 'All Notes',
                        onClick: () => {
                            routeActions.openList('Note');
                        },
                    }}
                />
            </ContentBox.Section>
        </ContentBoxSkeleton>
    );
}
